'use client';
// ------------------组件------------------
import { formatProductLink } from '@/utils';
import FlashSalesClient from './clientComponent/flashSalesClient';
import SaleTips from './clientComponent/saleTips';
import { useRouter } from 'next/navigation';
import { useTranslation } from '@/i18n/client';

interface FlashSalePropTypes {
  moduleData: any;
  currentMills: number;
  floorIndex: number;
  localInfo: any;
}

interface PageConfig {
  jumpParams?: string;
  products?: any[];
  happyHourProducts?: any[];
  swiperProducts?: any[];
  startTimeStamp?: number;
  startDate?: Date;
}

const Module: React.FC<FlashSalePropTypes> = ({
  moduleData,
  currentMills,
  localInfo,
  floorIndex,
}) => {
  const { t } = useTranslation();
  const router = useRouter();
  let pageConfig: PageConfig = {};

  const initConfig = (moduleData: any): PageConfig => {
    const { dataBatch, externalData } = moduleData;
    const externalDataBatchList = externalData?.data?.seckillBatchDtoList[0];
    const skuDiscountText = externalData?.data?.lightningDealsText?.skuDiscountText;

    const newPageConfig: PageConfig = {
      jumpParams: dataBatch?.Config[0]?.moreBtnLink,
      products: externalDataBatchList?.productList,
      happyHourProducts: externalData?.data?.happyHourBatchDtoList,
      swiperProducts: [],
      startTimeStamp: externalDataBatchList?.startTime,
      startDate: new Date(externalDataBatchList?.startTimeStr),
    };

    // --------------商卡信息--------------
    newPageConfig.swiperProducts =
      newPageConfig.happyHourProducts?.map((p: any, index: number) => {
        const swiperProduct = { ...p };
        swiperProduct.type = '1';
        swiperProduct.originalPrice = p?.originalPriceV2;
        swiperProduct.originalPriceTips = p?.originalPriceDesc;
        swiperProduct.currency = localInfo?.currencyCode;
        swiperProduct.languageCode = localInfo?.languageCode;
        swiperProduct.skuImg = p?.skuImg;
        swiperProduct.url = formatProductLink(p.skuId, p.skuName);

        swiperProduct.width = '120px';
        swiperProduct.height = 'auto';
        swiperProduct.containerStyle = {
          flex: '0 0 auto',
        };
        swiperProduct.priceStyle = {
          fontSize: '12px',
        };
        swiperProduct.realPriceJDIPriceParams = {
          symbolStyle: { fontSize: '12px' },
          integerStyle: { fontSize: '16px' },
          decimalPointStyle: { fontSize: '16px' },
          decimalPlaceStyle: { fontSize: '16px' },
          containerStyle: {
            display: 'block',
            lineHeight: '24px',
            fontWeight: 700,
            fontSize: '18px',
            color: '#4843B8',
          },
        };
        swiperProduct.originalPriceJDIPriceParams = {
          containerStyle: {
            fontWeight: '500',
            fontSize: '12px',
          },
        };

        swiperProduct.onClickProduct = () => {
          router.push(`/offer?channelType=1&selectedSkuId=${p.skuId}`);
        };

        swiperProduct.skuImgStyle = {
          width: '120px',
          height: '120px',
          borderRadius: '4px',
        };
        swiperProduct.saleTips = {
          discount: p.extInfo?.labels?.labelData?.['1']?.value,
          saveX: p.extInfo?.labels?.labelData?.['11']?.value,
          onlyXLeft: p?.stock < 10 ? p.stock : null,
        };
        swiperProduct.happyHour = true;
        swiperProduct.saleTipsDom = (
          <SaleTips
            labels={swiperProduct.saleTips}
            skuDiscountText={skuDiscountText}
            saleTextColor={swiperProduct.happyHour}
          />
        );
        swiperProduct.priority = floorIndex < 6 && index < 4;
        return swiperProduct;
      }) || [];

    newPageConfig.products?.forEach((p: any, index: number) => {
      p.type = '1';
      p.currency = localInfo?.currencyCode;
      p.languageCode = localInfo?.languageCode;
      p.skuImg = p?.imageUrl;
      p.url = formatProductLink(p.skuId, p.skuName);
      p.originalPrice = p?.originalPriceV2;
      p.originalPriceTips = p?.originalPriceDesc;
      p.width = '120px';
      p.height = 'auto';
      p.containerStyle = {
        flex: '0 0 auto',
      };
      p.priceStyle = {
        fontSize: '12px',
      };
      p.realPriceJDIPriceParams = {
        symbolStyle: { fontSize: '12px' },
        integerStyle: { fontSize: '16px' },
        decimalPointStyle: { fontSize: '16px' },
        decimalPlaceStyle: { fontSize: '16px' },
        containerStyle: {
          display: 'block',
          lineHeight: '24px',
          fontWeight: 700,
          fontSize: '18px',
        },
      };
      p.originalPriceJDIPriceParams = {
        containerStyle: {
          fontWeight: 500,
          fontSize: '12px',
        },
      };
      p.skuImgStyle = {
        width: '120px',
        height: '120px',
        borderRadius: '4px',
      };
      console.log(p, 'ppppp');
      p.saleTips = {
        discount: p.extInfo?.labels?.labelData?.['1']?.value,
        saveX: p.extInfo?.labels?.labelData?.['11']?.value,
        onlyXLeft: p?.stock < 10 ? p.stock : null,
        onlyLeft: p.extInfo?.labels?.labelData?.['3']?.value,
      };
      p.onClickProduct = () => {
        router.push(`/offer?channelType=0&selectedSkuId=${p.skuId}`);
      };
      p.saleTipsDom = <SaleTips labels={p.saleTips} />;
      p.priority = floorIndex < 6 && index < 4;
    });
    return newPageConfig;
  };

  pageConfig = initConfig(moduleData);
  const { externalData } = moduleData;
  const channelTextList = externalData?.data?.lightningDealsText?.channelTextList;

  const title = moduleData?.dataBatch?.Config[0]?.title || t('cms.flashSales.title');

  return (
    <FlashSalesClient
      moduleData={moduleData}
      pageConfig={pageConfig}
      channelTextList={channelTextList}
      title={title}
      currentTime={currentMills}
    />
  );
};

export default Module;
